const TipoProcesoOptions = [
  {
    label: 'Selecciona',
    value: '',
  },
  {
    label: 'Ordinario',
    value: 'Ordinario',
  },
  {
    label: 'Precampaña',
    value: 'Precampaña',
  },
  {
    label: 'Campaña',
    value: 'Campaña',
  }
];

export default TipoProcesoOptions;